var _defs, _path, _path2, _g, _polygon, _path3, _path4, _polygon2, _path5, _path6, _path7, _ellipse, _path8, _path9, _path10, _path11, _path12, _path13, _g2, _path14, _path15, _g3, _g4, _path16, _path17, _path18, _path19, _path20, _g5, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _ellipse2, _path34, _g6, _path35, _path36, _path37, _polygon3, _rect, _polygon4, _rect2, _rect3, _polygon5, _path38, _g7, _g8, _g9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlumber(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 865.76,
    height: 682.89,
    viewBox: "0 0 865.76 682.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.79,581.58s-93.38-64-97.15-194.88c-1.17-40.53,20.3-78.5,56-97.71l1.68-.89a302.7,302.7,0,0,0,68.94-49.36c14-13.39,30.88-30.37,49.81-51,0,0,174.91-245.38,371.21-147.23,0,0,196.3,62.92,149.75,363.67,0,0-39.55,297.15-450.69,243.71a295.76,295.76,0,0,1-100.06-31.42C210.16,607.42,192.51,595.9,177.79,581.58Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("style", {
    xmlns: "http://www.w3.org/1999/xhtml"
  }, "*, ::after, ::before { box-sizing: border-box; }\nimg, svg { vertical-align: middle; }\n"), /*#__PURE__*/React.createElement("style", {
    xmlns: "http://www.w3.org/1999/xhtml"
  }, "*, body, html { -webkit-font-smoothing: antialiased; }\nimg, svg { max-width: 100%; }\n"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M177.79,581.58s-93.38-64-97.15-194.88c-1.17-40.53,20.3-78.5,56-97.71l1.68-.89a302.7,302.7,0,0,0,68.94-49.36c14-13.39,30.88-30.37,49.81-51,0,0,174.91-245.38,371.21-147.23,0,0,196.3,62.92,149.75,363.67,0,0-39.55,297.15-450.69,243.71a295.76,295.76,0,0,1-100.06-31.42C210.16,607.42,192.51,595.9,177.79,581.58Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M177.79,581.58s-93.38-64-97.15-194.88c-1.17-40.53,20.3-78.5,56-97.71l1.68-.89a302.7,302.7,0,0,0,68.94-49.36c14-13.39,30.88-30.37,49.81-51,0,0,174.91-245.38,371.21-147.23,0,0,196.3,62.92,149.75,363.67,0,0-39.55,297.15-450.69,243.71a295.76,295.76,0,0,1-100.06-31.42C210.16,607.42,192.51,595.9,177.79,581.58Z",
    fill: "#fff",
    opacity: 0.7
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 158.77,
    y: 347.4,
    width: 505.52,
    height: 314,
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 664.3,
    y: 347.4,
    width: 476.57,
    height: 314,
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 461.64,
    cy: 579.01,
    rx: 46.77,
    ry: 42.31,
    fill: "#b3b3b3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 464.98,
    cy: 580.12,
    r: 32.29,
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "53.95 261.21 53.95 603.96 158.77 661.4 158.77 347.4 53.95 261.21",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1123.48 238.28 42.97 238.28 152.09 336.27 1135.3 336.27 1123.48 238.28",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.09,
    y: 336.27,
    width: 983.2,
    height: 11.13,
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.63,269.46s-15.59-17.82,6.68-15.59l189.3-4.46s42.09-6.68,52.22,10A168.1,168.1,0,0,1,469,287.27s14.92,24.5-11.8,26.73H267.58a56,56,0,0,1-18-2.93c-8.75-3-21-8.53-29.43-18.23Z",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.94,308.88a16.07,16.07,0,0,1-5.73-4.92c-5.21-7.19-14.33-24.32,18.36-22.91H416.64s20.15-2.69,22.55,11.79c0,0,13.48,21.16-26.58,21.16h-145A46.71,46.71,0,0,1,242.94,308.88Z",
    fill: "#b3b3b3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.59,269.46s-15.59-17.82,6.68-15.59l189.29-4.46s42.09-6.68,52.22,10A167.9,167.9,0,0,1,812,287.27s14.92,24.5-11.81,26.73H610.53a56,56,0,0,1-18-2.93c-8.75-3-21-8.53-29.43-18.23Z",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.89,308.88a16,16,0,0,1-5.72-4.92c-5.22-7.19-14.33-24.32,18.35-22.91H759.6s20.14-2.69,22.55,11.79c0,0,13.47,21.16-26.58,21.16h-145A46.72,46.72,0,0,1,585.89,308.88Z",
    fill: "#b3b3b3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.85,365.22a22.89,22.89,0,0,1-7.32-17.82H441.37v11.82s2.27,44.6-106.19,38.22a126.32,126.32,0,0,1-28.22-5C289.21,387.26,259.89,377.25,247.85,365.22Z",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.68,384.37h73.95s30.82-1.34,28.59,34.29L532.91,559s8.9,57.91-22.27,66.81c0,0-31.18,2.23-46.77-17.81,0,0-17.82-20.05,0-33.41,0,0,17.81-11.13,24.5,13.36,0,0,13.36,13.37,13.36-15.58l-8.34-141.78a10.45,10.45,0,0,0-10.24-9.84L394,419a17.32,17.32,0,0,1-17-17.32l.42-4.47S408,394.62,423.68,384.37Z",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.63,425.35c-.46-.93,21.23,4.45,34.59-6.69l.56,11.63s-12.25,10-33.13,4.76C493.65,435.05,494.89,432,491.63,425.35Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536,469.88h0a8,8,0,0,1-8-7.56l-1.3-23.38a8.67,8.67,0,0,1,8.65-9.14h0a8.66,8.66,0,0,1,8.66,8.66v23.41A8,8,0,0,1,536,469.88Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544,440.26h69.34s19.74.67,17.51-26.05H654.5l-1.66,22.36s-1.9,22.18-33.08,24.41l-75.72.89Z",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 621.98,
    y: 400.85,
    width: 35.63,
    height: 13.36,
    fill: "#2f2e41",
    "data-secondary": "true"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 608.62,
    y: 389.71,
    width: 55.67,
    height: 11.13,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.87,347.4s-.64,22.27,26.08,31.18c0,0,29,20,104.67,16.7H664.3V347.4Z",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.1,
    y: 211.56,
    width: 22.27,
    height: 31.18,
    rx: 3.4,
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 459.42,
    y: 211.56,
    width: 22.27,
    height: 31.18,
    rx: 3.4,
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 439.37,
    y: 220.46,
    width: 20.04,
    height: 17.82,
    fill: "#0071f2",
    "data-primary": "true"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.83,220.46v-57.9a42.31,42.31,0,0,1,42.31-42.31h0a42.31,42.31,0,0,1,42.31,42.31V173.7h-8.91V162.56a33.4,33.4,0,0,0-33.4-33.4h0a33.4,33.4,0,0,0-33.41,33.4v57.9Z",
    fill: "#0071f2",
    "data-primary": "true"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.64,169.24h26.72a0,0,0,0,1,0,0v23a1.54,1.54,0,0,1-1.54,1.54H512.17a1.54,1.54,0,0,1-1.54-1.54v-23A0,0,0,0,1,510.64,169.24Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "42.97 238.28 42.97 251.57 152.09 347.4 152.09 336.27 42.97 238.28",
    fill: "#b3b3b3"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "676.65 564.4 683.88 532.36 691.31 534.48 684.51 566.5 676.65 564.4",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M700.07,529l-5.32,6.08a3.2,3.2,0,0,1-3.24,1L683.87,534a3.22,3.22,0,0,1-2.34-2.76l-.84-8.44s.41-1.13-4-2.69l-13.79-2.4a1.28,1.28,0,0,1-1.05-1.49l1.65-9.09a1.29,1.29,0,0,1,1.55-1l17.8,4s3.9-1.95,9.83.69c.26.11.53.24.79.37l10.62,5.31s6.37,2.12,8.5,8.5c0,0,7.27,13.09,7.37,18.81a2.07,2.07,0,0,1-3.06,1.79,13.52,13.52,0,0,1-4.31-4.68s-6.25-8.92-10.56-12A1.42,1.42,0,0,0,700.07,529Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M358.93,584.33l75.47,6.43a7.18,7.18,0,0,1,4.27,1.9l8,7.51,1,.92a22.93,22.93,0,0,0,3.43,2.65c.57.36,1.16.69,1.76,1a18.68,18.68,0,0,0,3.25,1.3c.33.1.65.19,1,.26a24.76,24.76,0,0,0,18.41-2.73,1.26,1.26,0,0,0,0-2.19L464,595.08l-1.18-.65A8.75,8.75,0,0,1,460.7,593a4.59,4.59,0,0,1-.74-5.8l4.33-5.72c2.16-3.61,5.77-.72,5.77-.72l6.88,4.33c4.72,3.61,6.83,2.89,6.83,2.89,4.33-2.17-10.1-18-10.1-18-5.05-6.5-11.55-2.17-11.55-2.17l-11.65,7.36c-5.87,3.75-13.61,2.74-13.61,2.74l-77.11-7.57a5.9,5.9,0,0,0-6.42,5,18.44,18.44,0,0,0-.17,2.61S352.44,583.61,358.93,584.33Zm-2.16-6.86a4,4,0,1,1,4,4A4,4,0,0,1,356.77,577.47Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "457.79 585.77 451.3 596.6 441.94 590.82 448.41 580 457.79 585.77",
    opacity: 0.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M452.86,604.73a18.68,18.68,0,0,0,3.25,1.3L464,595.08l-1.18-.65A8.75,8.75,0,0,1,460.7,593Z",
    opacity: 0.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M444.42,604.39l1.45,1.49a1.73,1.73,0,0,0,2.32.15l2.91-2.29a22.93,22.93,0,0,1-3.43-2.65l-1-.92-2.1,1.65A1.73,1.73,0,0,0,444.42,604.39Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M444.42,604.39l1.45,1.49a1.73,1.73,0,0,0,2.32.15l2.91-2.29a22.93,22.93,0,0,1-3.43-2.65l-1-.92-2.1,1.65A1.73,1.73,0,0,0,444.42,604.39Z",
    opacity: 0.2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 329.4,
    cy: 321.03,
    rx: 38.46,
    ry: 28.66,
    transform: "translate(-81.48 527.78) rotate(-70.97)",
    fill: "#f9b499"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M337.28,298.57a26.23,26.23,0,0,1-9.86,2.78,5.75,5.75,0,0,0-4,2.14l-7.77,9.77s-3.87-.5-4.1-4l-9.15,0s-6.95,10.25-24.27-.57l3.36-7.14a24.34,24.34,0,0,0,2.24-8.46c.25-3.11,1.68-7.87,7.39-11.82C291.1,281.25,301.2,284.14,337.28,298.57Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M278.11,308.67l-8.66,5.77s17.32,23.1,24.53,33.92c0,0,5.17-7.78,7.64-7.5,0,0-5.77-13,1.6-31.62h-.84S294.71,319.49,278.11,308.67Z",
    fill: "#f9b499"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M291.1,281.25l46.18,17.32,34.64,15.87c13,7.22,18.19,6.59,18.19,6.59,5.21-2.07-21.8-19.58-21.8-19.58,7.94-18,6.5-31.75,6.5-31.75-1.76-22.31-41.28-20.74-55.94-19.37a20.27,20.27,0,0,0-12.12,5.39,47,47,0,0,0-5.8,6.83,81,81,0,0,0-6.62,11.3C292.23,278.13,291.1,281.25,291.1,281.25Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M294.33,273.85l7.59,3.79s8-8.65-1-15.09A81,81,0,0,0,294.33,273.85Z",
    opacity: 0.2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M301.62,340.86a11.15,11.15,0,0,0-4.47,3.33s-2.62-5,2.52-18.44C299.67,325.75,298.43,330.48,301.62,340.86Z",
    fill: "#f7a48b"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M96.72,542.06c.49,1.81.93,3.63,1.29,5.47,1.09,5.52,6,20.11,28.1,25.49a58.38,58.38,0,0,0,22.83.92,61.31,61.31,0,0,0,13-3.5c21.61-8.44,69.21-29.18,122.64-66.21l-18.35,82.34L260.79,611s18,5.77,59.89-1.45a59.92,59.92,0,0,0,10.09-3.26,12.39,12.39,0,0,0,7.08-8.48c3.66-15.08,14.41-60.48,23.25-108.77,0,0,4.58,3.06,10.75-2.81a27.44,27.44,0,0,0,3.68-4.4S389,463.7,388,440.36c0-.83-.09-1.68-.17-2.52,0,0-2.88-10.82-19.48-12.27a6.79,6.79,0,0,1-7.21-2.16L301.89,364.2a3.37,3.37,0,0,1-.85-3.32l.12-.38a3.36,3.36,0,0,0-.5-2.91L294,348.36l-24.53-33.92s-4-8.11-9.23-.8L255.28,321s-20.47,6.4-35.62,13.62c0,0-13,5.77-21.65,16.6l-37.52,45.46S148.22,409,146.77,416.19c0,0,0,6.5-10.1,12.27,0,0-14.43,8.66-14.43,18.76l-1.44,10.83S85.13,499.21,96.72,542.06Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M226.15,393.46h.07a.36.36,0,0,0,.29-.41c-4.08-22.6,4.71-39.6,12.79-49.88a76.42,76.42,0,0,1,18.76-17.1.36.36,0,0,0,.12-.49.35.35,0,0,0-.49-.13,77.25,77.25,0,0,0-18.94,17.25c-8.18,10.4-17.08,27.6-12.95,50.47A.35.35,0,0,0,226.15,393.46Z"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M255,424.13s-15.16,6.49-16.6,6.49S224,414.75,219.66,390.21C219.66,390.21,223.27,400.32,255,424.13Z",
    opacity: 0.2
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M254.34,423.28a1.09,1.09,0,0,1,1.52.17c8.36,10.45,32.44,18.33,32.68,18.41a1.14,1.14,0,0,1,.51.35c16.23,20,44.42,27.52,50.79,29,.27-10,9.92-20.64,10.33-21.09,8.26-9.63,8.34-19.37,8.34-19.49a1.09,1.09,0,1,1,2.17,0c0,.43,0,10.62-8.89,20.94-.1.11-10.35,11.43-9.77,20.86,2.78,12.85,15.53,16.28,15.73,16.33a1.08,1.08,0,0,1,.79,1.31,1.1,1.1,0,0,1-1.05.82l-.27,0c-.57-.15-13.86-3.65-17.18-17.37-5-1.1-35.13-8.55-52.47-29.66-3-1-25.06-8.59-33.4-19A1.09,1.09,0,0,1,254.34,423.28Z",
    opacity: 0.3
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.32,525.52h0c27.2-2.86,47.59-17.23,47.8-17.38l49.06-34c9.09-7.74,12.38-7.83,12.42-7.83h0s.05,0,.08,0c3.12-.66,5-1.66,5.6-3a2,2,0,0,0,.05-1.55c0-1.36.33-2.25,1-2.62,1.3-.75,3.54.58,3.56.6,1.58.87,2.82,1,3.71.33,2.29-1.67,1.15-7.91,1-8.56.13-2.25.64-3.56,1.49-3.8,2.07-.57,6,4.49,7.38,6.49a.36.36,0,0,0,.5.09.36.36,0,0,0,.1-.5c-.53-.78-5.24-7.59-8.17-6.77-1.22.33-1.88,1.81-2,4.5a.28.28,0,0,0,0,.09c.35,1.78.92,6.67-.73,7.88-.65.47-1.63.34-2.93-.38-.09-.06-2.61-1.55-4.28-.6-.91.52-1.37,1.64-1.35,3.33a.39.39,0,0,0,0,.18,1.15,1.15,0,0,1,0,1c-.35.74-1.5,1.78-5,2.53-.47,0-4,.43-12.82,8l-49,34c-.2.15-20.45,14.41-47.46,17.26a.36.36,0,0,0-.32.39A.37.37,0,0,0,158.32,525.52Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.06,532.73a1.06,1.06,0,0,0,.86-.42C145.48,517.14,150,498.17,150,498a1.07,1.07,0,0,0-.81-1.3,1.09,1.09,0,0,0-1.3.81c0,.19-4.41,18.72-15.68,33.5a1.08,1.08,0,0,0,.21,1.52A1,1,0,0,0,133.06,532.73Z"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M202.26,445.55s-28.06-3.38-51.16-2.66a78.92,78.92,0,0,0-5,13l31.41.45Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M140.28,443.61A52.74,52.74,0,0,0,136,456.33l-13.69,1.54a3,3,0,0,1-3.34-2.66,10.52,10.52,0,0,1,.36-3.66s.72-5.05,7.22-5.77Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M148.94,573.94c9.38,15.6,34.64,46.47,34.64,46.47,4.33,7.94,15.15,1.44,15.15,1.44l67.52-35.28,18.35-82.34c-53.43,37-101,57.77-122.64,66.21A61.31,61.31,0,0,1,148.94,573.94Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M148.94,573.94c9.38,15.6,34.64,46.47,34.64,46.47,4.33,7.94,15.15,1.44,15.15,1.44l67.52-35.28,18.35-82.34c-53.43,37-101,57.77-122.64,66.21A61.31,61.31,0,0,1,148.94,573.94Z",
    opacity: 0.2
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M191.84,557.26c6.8,1.1,28.22-2,47.24-5.33h.06c17.41-3,32.8-6.13,33.12-6.19a.37.37,0,0,1,.43.28.37.37,0,0,1-.28.43c-1.28.26-16,3.23-32.61,6.12,1.13,1,6.49,3.83,31.08,3.26a.37.37,0,0,1,0,.73c-2.26.05-4.35.07-6.3.07-21.07,0-24.93-2.84-25.64-3.92-16.28,2.81-34.26,5.51-43.44,5.51a24.71,24.71,0,0,1-3.8-.24.36.36,0,0,1-.3-.41A.36.36,0,0,1,191.84,557.26Z",
    opacity: 0.2
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M286.77,594.07a1.09,1.09,0,0,0,1.06-.85l14.43-66.39c12.72-51.58,10.3-57.94,10-58.5l-1.88,1.08a.69.69,0,0,1-.05-.1c.1.26,2.18,7-10.16,57l-14.44,66.42a1.08,1.08,0,0,0,.83,1.29Z"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M371.85,486.26c10,3.68,119.86,8.59,119.86,8.59,10.82,0,36.08,10.82,36.08,10.82,12.27,7.94,13,3.61,13,3.61,2.88-5-16.6-11.55-16.6-14.43S535,496.29,535,496.29c17.32,5,18.77,2.17,18.77,2.17,4.33-5.78-24.54-13-24.54-13-5.77-3.61,11-.72,11-.72,23.27,5.05,21.46,0,21.46,0,2.17-6.5-30.3-10.83-30.3-10.83v-1.44c35.36,2.16,31.75-2.89,31.75-2.89-.72-4.33-13.71-5-13.71-5l-24.08-4.49c-5.35-1.15-2.15-5.4.09-7.7a24.23,24.23,0,0,0,4.49-6.24c3.19-6.54.74-9,.74-9-2-4.41-5.91-.51-8.25,2.45a34.76,34.76,0,0,1-6.22,6.08,102.53,102.53,0,0,1-22.55,13.12c-5.25,2.88-16.38,0-16.38,0C434,452.27,388,440.36,388,440.36c1,23.34-12.43,41.5-12.43,41.5A27.44,27.44,0,0,1,371.85,486.26Z",
    fill: "#f9b499"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M354.83,521.48,388,554.27,415,569a13.57,13.57,0,0,0,3.18,1.25c3.54.9,10,2.53,6.4,6.86,0,0-3.28,4.47-15,.8a12.69,12.69,0,0,1-3.12-1.4c-1.22-.79-3.93-1.94-8.51-.89,0,0-8.35,3.3-20.62-3.2L360,570.26,345.74,564Z",
    fill: "#f9b499"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M415.72,587.49a8.18,8.18,0,0,1,1.77,3.69c.31,1.65.11,3.58-2.27,4,0,0-3.82.72-7-3.24,0,0-2.42,12.62-12.53,4.69l-2.94-2.66s-3.55,5.54-9.32,1.93c0,0-4.33,4.33-10.11-5.77,0,0-7.21-17.32,2.89-14.43,0,0,6.21-2.73,11.77,3.69,0,0,4.83-5.86,9.88,1.36l4.33,4.33S403.6,572.69,415.72,587.49Z",
    fill: "#f9b499"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M388,579.36a79.69,79.69,0,0,0,4.77,14.58A78.44,78.44,0,0,0,388,579.36Z",
    fill: "#f7a48b"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M376.25,575.67a153.64,153.64,0,0,0,7.22,20.2,157.66,157.66,0,0,0-7.22-20.2Z",
    fill: "#f7a48b"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M402.23,585.05a28.2,28.2,0,0,0,6,6.86,28.23,28.23,0,0,0-6-6.86Z",
    fill: "#f7a48b"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M385.7,574.82a150.17,150.17,0,0,1-15.95-14.31,51.76,51.76,0,0,0,15.95,14.31Z",
    fill: "#f7a48b"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M172.14,606.06l-2.27,2.08-30.31,7.94L123,580l11.34-5.6s8.87.71,14.64-.46q3.75,5.82,7.94,11.83C162,593.05,167.09,599.81,172.14,606.06Z",
    fill: "#f9b499"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M173.47,615.36s2.17-6.5-3.6-7.22l-8.66-3.61s-5.05-2.16-9.38,2.89c0,0-8.66,10.1-13.71.72,0,0-8.27-16.76-12.8-29.31,0,0-15.35,6.22-17.51,11.27,0,0,14.53,18.78,22,36.35a23.3,23.3,0,0,0,6.47,8.72c6.06,5.11,16.71,14,23.49,19a16.27,16.27,0,0,0,9,3.19l34.27,1.27S206,650,188.63,642.78c0,0-14.43-3.61-15.16-12.27Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M203.06,658.66s0,3.6-6.49,3.6l-28.15-.72a15.78,15.78,0,0,1-12.9-4.85s-17.58-11.79-37-32.34c0,0-27.34-27-10.74-34.25a187.25,187.25,0,0,1,22,36.35,23.14,23.14,0,0,0,6.47,8.72s16.25,13.13,23.49,19c0,0,5.08,3.36,9,3.19Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M257.18,628.35c10.1,6.49,26.11,11.17,26.11,11.17C295,638.44,294,627.63,294,627.63c0-7.94,5.76-7.22,5.76-7.22h2.68l.22-.72,2.36-7.85c-31.56,3.71-44.21-.81-44.21-.81Z",
    fill: "#f9b499"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M250.69,649.27S293.44,658,307,660.1c25.43,3.91,57.06-.43,62.94-1.3a1.25,1.25,0,0,0,1.08-1.33c-.21-2.77-3.61-9.9-30.82-16.13a70.15,70.15,0,0,1-24.54-15.88s-4.33-5.05-9.38-5.05h-6.51s-5.76-.72-5.76,7.22c0,0,1,10.81-10.69,11.89,0,0-16-4.68-26.11-11.17A99.46,99.46,0,0,0,250.69,649.27Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M257.18,661.71l27.42,2.75c51.24,3.63,85.15-2.75,85.15-2.75,3.61-.56,1.24-4.24,1.24-4.24a1.25,1.25,0,0,1-1.08,1.33c-5.88.87-37.51,5.21-62.94,1.3-13.53-2.09-56.28-10.83-56.28-10.83C247.08,662.26,257.18,661.71,257.18,661.71Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 306.97,
    cy: 300.37,
    rx: 8.66,
    ry: 10.46,
    fill: "#f9b499"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M157.16,467.07a1,1,0,0,0,.48-.12A714.55,714.55,0,0,1,228,436.7a1.09,1.09,0,1,0-.73-2.05A722.73,722.73,0,0,0,156.68,465a1.09,1.09,0,0,0,.48,2.06Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.16,467.07a1,1,0,0,0,.48-.12A714.55,714.55,0,0,1,228,436.7a1.09,1.09,0,1,0-.73-2.05A722.73,722.73,0,0,0,156.68,465a1.09,1.09,0,0,0,.48,2.06Z"
  }))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M571.33,604.56,579.82,646s2.12,18,13.8,19.11H696.09s9,1.06,10.08-17l5.69-43.53Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M571.33,604.56l1.91,9.34s102-3.61,135,18.48l3.63-27.82Z",
    opacity: 0.3
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M576.63,530.23s-9.55,9.56-2.12,21.24c0,0,2.12,3.19,8.5,6.37,0,0,2.75.92,4.85,7a15.3,15.3,0,0,1,.64,2.61l1.28,7.87h14.85L600,560a8.31,8.31,0,0,1,2-8.47,14.2,14.2,0,0,0,2.74-3.92c1.73-3.83,3.56-10.88-2.14-17.13a16.91,16.91,0,0,0-12.53-5.4,9.15,9.15,0,0,0-4.45,1L591,537.57a1.32,1.32,0,0,1-.61,1.73l-6.16,3.08a1.32,1.32,0,0,1-1.78-.59Z",
    fill: "#ccc"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "591.5 565.27 593.94 575.36 599.88 575.36 596.81 563.15 591.5 565.27",
    opacity: 0.2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 636.33,
    y: 566.4,
    width: 16.88,
    height: 1.06,
    transform: "translate(45.81 1182.07) rotate(-87.09)",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "686.33 566.99 674.02 563.7 672.93 567.8 674.54 568.23 672.37 578.55 681.48 580.47 683.55 570.64 685.24 571.1 686.33 566.99",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 613.8,
    y: 481.39,
    width: 15.93,
    height: 96.62,
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 621.23,
    y: 481.39,
    width: 8.49,
    height: 96.62,
    opacity: 0.2
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "563.36 575.36 717.23 575.36 714.14 608.28 569.43 608.28 563.36 575.36",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M650.63,553.85l2,.16,2.48-29.89a4,4,0,0,0-3.63-4.29l-5.86-.48A4,4,0,0,0,641.3,523l-2.48,29.9,2.58.21v2.35l-4-.3-.4,5.3,15.88,1.18.4-5.29-2.85-.21Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    x: 629.09,
    y: 535.44,
    width: 28.57,
    height: 1.06,
    transform: "translate(54.09 1130.89) rotate(-85.07)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    x: 633.34,
    y: 535.44,
    width: 28.57,
    height: 1.06,
    transform: "translate(57.97 1135.13) rotate(-85.07)"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    x: 637.59,
    y: 535.44,
    width: 28.57,
    height: 1.06,
    transform: "translate(61.85 1139.36) rotate(-85.07)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlumber);
export default __webpack_public_path__ + "static/media/Plumber.6fb199b6b6e6ead4e3543e914177dd17.svg";
export { ForwardRef as ReactComponent };